import { Text } from "../units/Text";
import { useRef, useEffect } from "react";
import { DashedDivider } from "../units/Divider";
import { BoxWrapper } from "../Wrappers/Wrappers";


type filterOptions = {
    label: string;
    value: any;
}


interface TableFilterProps {
    label: string | number;
    options: filterOptions[];
    selected: any | undefined;
    isOpen: boolean;
    setOpen: (isOpen:boolean) => void;
    dataSetter: (value: any | undefined) => void;
}

export const TableFilter = ({label, options, selected, isOpen, setOpen, dataSetter}: TableFilterProps) => {
    
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const isContentAreaClick = alertContentRef.current && event.target instanceof Node && alertContentRef.current.contains(event.target) ? true : false
            if (!isContentAreaClick) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const alertContentRef = useRef<HTMLDivElement | null>(null);
    const degree = isOpen ? 0 : 180
    const option = options.find((item) => item.value === selected);
    const notSelectedText = 'Не выбранно'

    return (
        <div className="select-outter-wrapper" ref={alertContentRef} style={{height:'36px', width: '100%', minWidth: "fit-content", textWrap:'nowrap'}} onClick={() => setOpen(!isOpen)}>
            <div className="filter-wrapper">
                <div className="flex align-center space-between">
                    <div className="flex narrow-gap">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.1632 4.69359H1.83687C1.31972 4.69359 0.900035 4.24709 0.900035 3.6969C0.900035 3.1467 1.31972 2.7002 1.83687 2.7002H16.1632C16.6812 2.7002 17.1 3.1467 17.1 3.6969C17.1 4.24709 16.6812 4.69359 16.1632 4.69359ZM12.4933 9.22521C12.4933 8.67502 12.0745 8.22851 11.5565 8.22851H1.83686C1.31971 8.22851 0.900024 8.67502 0.900024 9.22521C0.900024 9.7754 1.31971 10.2219 1.83686 10.2219H11.5565C12.0745 10.2219 12.4933 9.7754 12.4933 9.22521ZM7.88663 14.3035C7.88663 13.7524 7.46782 13.3068 6.9498 13.3068H1.83686C1.31971 13.3068 0.900024 13.7524 0.900024 14.3035C0.900024 14.8546 1.31971 15.3002 1.83686 15.3002H6.9498C7.46782 15.3002 7.88663 14.8546 7.88663 14.3035Z" fill="black"/>
                        </svg>
                        <Text>{label}</Text>
                        <Text color='orange' className='bold'>{ option ? option.label : notSelectedText }</Text>
                    </div>
                    <svg className='select-arrow' width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{rotate:`${degree}deg`}}>
                        <path d="M10.9652 7.5498L12.6781 5.93115L6.68282 0.265882L0.68753 5.93115L2.40047 7.5498L6.68282 3.50318L10.9652 7.5498Z" fill="black"/>
                    </svg>
                </div>
                { DashedDivider() }
                {isOpen && (
                    <>
                    <BoxWrapper bg="bg-primary" r="r15" className="options standart-border show-up-quick">
                        {options.map((item, index) => (
                            <div key={index} className="option-row" onClick={(e) => {dataSetter(item.value); setOpen(false)}}>
                                <Text color='secondary' className={ item.value === selected ? 'underline' : '' }>{item.label}</Text>
                            </div>
                        ))}
                        <div className="option-row" onClick={(e) => {dataSetter(undefined); setOpen(false)}}>
                            <Text color='secondary' className={ undefined === selected ? 'underline' : '' }>{notSelectedText}</Text>
                        </div>
                    </BoxWrapper>
                    </>
                )}
            </div>
        </div>
    )
}


export const TablePaginationSelector = ({label, options, selected, isOpen, setOpen, dataSetter}: TableFilterProps) => {
    
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const isContentAreaClick = alertContentRef.current && event.target instanceof Node && alertContentRef.current.contains(event.target) ? true : false
            if (!isContentAreaClick) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const alertContentRef = useRef<HTMLDivElement | null>(null);
    const degree = isOpen ? 0 : 180
    const option = options.find((item) => item.value === selected);
    const notSelectedText = 'Не выбранно'

    return (
        <div className="select-outter-wrapper" ref={alertContentRef} style={{height:'36px', width: "fit-content", textWrap:'nowrap'}} onClick={() => setOpen(!isOpen)}>
            <div className="filter-wrapper">
                <div className="flex align-center space-between">
                    <div className="flex narrow-gap">
                        <Text>Страниц</Text>
                        <Text color='orange' className='bold'>{ option ? option.label : notSelectedText }</Text>
                    </div>
                    <svg className='select-arrow' width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{rotate:`${degree}deg`}}>
                        <path d="M10.9652 7.5498L12.6781 5.93115L6.68282 0.265882L0.68753 5.93115L2.40047 7.5498L6.68282 3.50318L10.9652 7.5498Z" fill="black"/>
                    </svg>
                </div>
                { DashedDivider() }
                {isOpen && (
                    <>
                    <BoxWrapper bg="bg-primary" r="r15" className="options standart-border show-up-quick">
                        {options.map((item, index) => (
                            <div key={index} className="option-row" onClick={(e) => {dataSetter(item.value); setOpen(false)}}>
                                <Text color='secondary' className={ item.value === selected ? 'underline' : '' }>{item.label}</Text>
                            </div>
                        ))}
                    </BoxWrapper>
                    </>
                )}
            </div>
        </div>
    )
}